import { render, staticRenderFns } from "./BirthDateForm.vue?vue&type=template&id=53349a4e&scoped=true"
import script from "./BirthDateForm.vue?vue&type=script&lang=js"
export * from "./BirthDateForm.vue?vue&type=script&lang=js"
import style0 from "./BirthDateForm.vue?vue&type=style&index=0&id=53349a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53349a4e",
  null
  
)

export default component.exports